"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _AdvancedAnalytics = _interopRequireDefault(require("@rsuite/icon-font/lib/application/AdvancedAnalytics"));

// Generated by script, don't edit it please.
var AdvancedAnalytics = (0, _createSvgIcon["default"])({
  as: _AdvancedAnalytics["default"],
  ariaLabel: 'advanced analytics',
  category: 'application',
  displayName: 'AdvancedAnalytics'
});
var _default = AdvancedAnalytics;
exports["default"] = _default;
module.exports = exports.default;